module.exports = "/_next/static/images/7e57e1382f02b2d91ecbeab52de4056d-phone@3x.png.webp";